export enum UserCountry {
  UNITED_STATES = 'United States',
  UNITED_STATES_OF_AMERICA = 'UNITED STATES OF AMERICA',
  CANADA = 'Canada',
}
